module.exports = __webpack_public_path__ + "static/img/postervideo.06869bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/postervideo.jpg
// module id = 747
// module chunks = 2 3 4 5 50